module.exports = __webpack_public_path__ + "static/img/land_logo.119dd9b4.svg";